// src/components/RH/inputs/cargos.js
const LISTA_CARGOS = [
  "Atendente de Loja",
  "Vendedor de Acessórios",
  "Caixa",
  "Estoquista",
  "Repositor de Loja",
  "Consultor de Estilo",
  "Assistente de Visual Merchandising",
  "Supervisor de Vendas",
  "Gerente de Loja",
  "Líder de Estoque",
  "Analista de E-commerce",
  "Assistente de Atendimento ao Cliente",
  "Gerente de E-commerce",
  "Coordenador de Marketing Digital",
  "Auxiliar Administrativo"
];

export default LISTA_CARGOS;
